export const sizeOptions = ["xx-small", "x-small", "small", "default", "large"];
export const variantOptions = ["flat", "outlined", "text", "text-inline", "appearance-link"];
export const smVariantOptions = variantOptions;
export const colorOptions = [
  "primary",
  "secondary",
  "danger",
  "text",
  "error",
  "warning",
  "success",
  "info",
  "white",
  "custom",
];
export const densityOptions = ["default", "compact"];

export const props = Object.freeze({
  tag: {
    type: String,
    default: "button",
    validator: (value) => ["button", "a"].includes(value),
  },
  label: {
    type: String,
    default: undefined,
  },
  color: {
    type: String,
    default: "primary",
  },
  size: {
    type: String,
    validator: (value) => sizeOptions.includes(value),
    default: "default",
  },
  variant: {
    type: String,
    validator: (value) => variantOptions.includes(value),
    default: "flat",
  },
  /**
   * Change the button to a specific variant on small screens.
   *
   * @type {String}
   * @default undefined
   */
  smVariant: {
    type: String,
    validator: (value) => smVariantOptions.includes(value),
    default: undefined,
  },

  /**
   * Disable the button.
   *
   * @type {Boolean|String}
   * @default false
   */
  disabled: {
    type: [Boolean, String],
    default: false,
  },
  /**
   * Apply a specific icon using the sp-icon component.
   * The button will become round.
   *
   * @type {String|Boolean}
   * @default false
   */
  icon: {
    type: [String, Boolean],
    default: false,
  },
  /**
   * Show a loading spinner.
   *
   * @type {Boolean|String}
   * @default false
   */
  loading: {
    type: [Boolean, String],
    default: false,
  },
  /**
   * Make the button full width.
   *
   * @type {Boolean|String}
   * @default false
   */
  block: {
    type: [Boolean, String],
    default: false,
  },
  /**
   * Make the button full width on small screens (mobile).
   *
   * @type {Boolean|String}
   * @default false
   */
  blockSm: {
    type: [Boolean, String],
    default: false,
  },
  /**
   * Stack the button prepend content and append.
   *
   * @type {Boolean|String}
   * @default false
   */
  stacked: {
    type: [Boolean, String],
    default: false,
  },
  density: {
    type: String,
    validator: (value) => densityOptions.includes(value),
    default: "default",
  },
  densitySmCompact: {
    type: [Boolean, String],
    default: true,
  },
  noWrap: {
    type: [Boolean, String],
    default: false,
  },
  /**
   * Creates a sp-icon component before default content in the prepend slot.
   *
   * @type {String}
   * @default undefined
   */
  prependIcon: {
    type: String,
    default: undefined,
  },
  /**
   * Creates a sp-icon component after default content in the append slot.
   *
   * @type {String}
   * @default undefined
   */
  appendIcon: {
    type: String,
    default: undefined,
  },
});
